<template>
  <div class="screening">
    <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">创建</el-button>
    <el-table :data="list" class="table">
      <el-table-column label="标题" prop="title">
      </el-table-column>
      <el-table-column label="标题(英文)" prop="title_en">
      </el-table-column>
      <el-table-column label="封面">
        <template slot-scope="scope">
          <img class="thumb" :src="scope.row.thumb">
        </template>
      </el-table-column>
      <el-table-column label="时间" prop="time">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showAppPath(scope.row)">路径</el-button>
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="per_page"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <el-dialog :title="!edit?'创建':'编辑'" :visible.sync="dialogVisible" width="900px">
      <el-form ref="form" :model="form" label-width="110px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="标题" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="标题(英文)" prop="title_en">
          <el-input v-model="form.title_en" placeholder="标题" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="封面" prop="thumb">
          <div class="images">
            <img v-if="form.thumb" class="thumb cursor-pointer" :src="form.thumb" title="点击更换" @click="selectThumb('thumb')">
            <div v-else class="addimg" @click="selectThumb('thumb')">+</div>
          </div>
        </el-form-item>
        <el-form-item label="时间" prop="time">
          <el-input v-model="form.time" placeholder="时间" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="轮播图" prop="images">
          <div class="images">
            <img v-for="item in form.images" :key="item" class="thumb cursor-pointer" :src="item" title="点击更换" @click="selectThumb2">
            <div class="addimg" @click="selectThumb2">+</div>
          </div>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6}"
            placeholder="请输入内容"
            v-model="form.description">
          </el-input>
        </el-form-item>
        <el-form-item label="描述(英文)" prop="description_en">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6}"
            placeholder="请输入内容"
            v-model="form.description_en">
          </el-input>
        </el-form-item>
        <el-form-item label="作品列表">
          <el-radio-group v-model="form.is_show_works">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
          <div class="movie-list">
            <div class="item" v-for="(item,index) in form.movie" :key="index">
              <el-select v-model="item.movie_id" placeholder="请选择">
                <el-option
                  v-for="item in movies"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-input class="input" v-model="item.price" placeholder="请输入价格"></el-input>
              <el-button type="text" @click="handleup(index)">上移</el-button>
              <el-button type="text" @click="handledown(index)">下移</el-button>
              <el-button type="text" @click="handledelete(index)">删除</el-button>
            </div>
            <el-button icon="el-icon-plus" size="small" @click="handleplusMovie">添 加</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="!edit" type="primary" @click="handleSubmit">确 定</el-button>
        <el-button v-show="edit" type="primary" @click="handleSubmit2">保存更改</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="路径" center width="800px">
      <el-form label-width="80px">
        <el-form-item label="小程序">
          <el-input :value="miniAppPath">
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'
export default {
  name: 'screening',
  components: {
    UploadImg
  },
  data () {
    return {
      edit: false,
      list: [],
      page: 1,
      per_page: 10,
      total: 0,
      current: {},
      dialogVisible: false,
      dialogVisible2: false,
      miniAppPath: '',
      form: {
        title: '',
        title_en: '',
        thumb: '',
        time: '',
        images: [],
        description: '',
        description_en: '',
        is_show_works: 1,
        movie: []
      },
      movies: []
    }
  },
  created () {
    this.getList()
    this.getMovie()
  },
  methods: {
    showAppPath (row) {
      this.miniAppPath = 'pages/screeningDetail/index?uuid=' + row.uuid
      this.dialogVisible2 = true
    },
    editItem (row) {
      this.current = JSON.parse(JSON.stringify(row))
      this.form = {
        title: this.current.title,
        title_en: this.current.title_en,
        thumb: this.current.thumb,
        time: this.current.time,
        images: this.current.images,
        description: this.current.description,
        description_en: this.current.description_en,
        is_show_works: this.current.is_show_works,
        movie: this.current.movie
      }
      this.edit = true
      this.dialogVisible = true
    },
    deleteItem (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/screening-programs/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getList()
        })
      }).catch()
    },
    handleup (index) {
      if (index === 0) return
      let pre = this.form.movie[index - 1]
      this.form.movie.splice(index - 1, 1)
      this.form.movie.splice(index, 0, pre)
    },
    handledown (index) {
      if (index === this.form.movie.length - 1) return
      let next = this.form.movie[index + 1]
      this.form.movie.splice(index + 1, 1)
      this.form.movie.splice(index, 0, next)
    },
    handledelete (index) {
      this.form.movie.splice(index, 1)
    },
    handleSubmit () {
      request({
        url: '/screening-programs',
        method: 'post',
        data: this.form
      }).then(res => {
        this.$message.success('创建成功')
        this.getList()
        this.dialogVisible = false
      })
    },
    handleSubmit2 () {
      request({
        url: '/screening-programs/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: this.form
        }
      }).then(res => {
        this.$message.success('更新成功')
        this.getList()
        this.dialogVisible = false
      })
    },
    handleplusMovie () {
      this.form.movie.push({
        movie_id: '',
        price: ''
      })
    },
    handleCreate () {
      this.edit = false
      this.dialogVisible = true
      this.$nextTick(() => {
        this.form = {
          title: '',
          title_en: '',
          thumb: '',
          time: '',
          images: [],
          description: '',
          description_en: '',
          is_show_works: 1,
          movie: []
        }
      })
    },
    handleSizeChange (e) {
      this.per_page = e
      this.page = 1
      this.getList()
    },
    handleCurrentChange (e) {
      this.page = e
      this.getList()
    },
    selectThumb (key) {
      let list = []
      if (this.form[key]) {
        list = [this.form[key]]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form[key] = res[0]
        }
      }).catch()
    },
    selectThumb2 () {
      let list = this.form.images
      this.$refs.upload.show(list, 'other', 100).then(res => {
        if (res.length) {
          this.form.images = res
        }
      }).catch()
    },
    getList () {
      request({
        url: '/screening-programs',
        params: {
          per_page: this.per_page,
          page: this.page
        }
      }).then(res => {
        this.list = res.data.list
        this.total = res.data.item_total
      })
    },
    getMovie () {
      request({
        url: '/movie'
      }).then(res => {
        this.movies = res.data.list
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 20px!important;
}
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
}
.pager {
  margin: 15px 0;
}
.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}
.images {
  display: flex;
  flex-wrap: wrap;
  .thumb {
    margin-right: 10px;
  }
}
.thumb {
  height: 50px;
  width: auto;
}
.movie-list {
  margin-top: 10px;
  .item {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    .input {
      margin: 0 10px;
      width: 220px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/movie/screening.vue